@for (transition of availableTransitions(); track transition.targetStatus) {
  <button mat-menu-item (click)="updateStatus.emit(transition.targetStatus)">
    <mat-icon [class]="transition.iconClass">{{ transition.icon }}</mat-icon>
    <span>{{ transition.label }}</span>
  </button>
}
